import React from 'react';
import { bonuses, bonusesTotal } from '../data/content';
export function Bonuses() {
  return <section id="bonos" className="bg-night-panel" data-id="element-20" data-mp="pkhg03f3hqhl">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-21" data-mp="pm2bpwd5bfh1">
        <div className="mx-auto max-w-2xl text-center" data-id="element-22" data-mp="aua8ujujftw7">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-23" data-mp="ftwmuvi6xe62">
            Incluidos hoy, sin costo extra
          </p>
          <h2 className="mt-3 font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
          fontSize: "40px"
        }} data-id="element-24" data-mp="1stzmffglxtk">
            5 bonos de regalo
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-25" data-mp="3o3g0q74jffo2">
            Con tu GPS Bíblico recibís también estos 5 recursos digitales. Valor total de
            los bonos: <span className="line-through" data-id="element-26" data-mp="1martznsoqa3j">{bonusesTotal}</span>. Hoy, gratis.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="1r8tduaxxqdg2">
          {bonuses.map(bonus => <article key={bonus.title} className="flex gap-4 rounded-2xl border border-gold-soft/30 bg-night p-5 sm:flex-col sm:gap-5 sm:p-6" data-id="element-28" data-mp="3icbunweqtxof">
              <img src={bonus.image} alt={`Portada de ${bonus.title}`} className="h-28 w-20 flex-none rounded-lg object-contain shadow-[0_14px_22px_rgba(0,0,0,0.45)] sm:h-40 sm:w-28 sm:self-center" data-id="element-29" data-mp="3r68h7cbtlc4d" />

              <div className="flex flex-1 flex-col" data-id="element-30" data-mp="2uh95fnc11s7f">
                <span className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-31" data-mp="2uikarrl4f80n">
                  {bonus.label}
                </span>
                <h3 className="mt-1.5 font-display text-lg font-semibold leading-snug text-parchment sm:text-xl" data-id="element-32" data-mp="33ge3ytnl9ljl">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-sm font-medium italic text-gold-soft" data-id="element-33" data-mp="irg9swey2d2e">
                  {bonus.subtitle}
                </p>
                <p className="mt-2 font-sans text-[0.95rem] leading-relaxed text-parchment/70" data-id="element-34" data-mp="3ciekez4q7mwz">
                  {bonus.description}
                </p>
                <p className="mt-3 font-sans text-sm text-parchment/60 sm:mt-auto sm:pt-4" data-id="element-35" data-mp="3lj31y3tbw5em">
                  Valor: <span className="line-through" data-id="element-36" data-mp="3qj7jzy9vx86y">{bonus.value}</span> —{' '}
                  <span className="font-semibold text-gold-soft" data-id="element-37" data-mp="2tsf1ktzhb420">GRATIS</span>
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}